import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { PDFViewer } from "@react-pdf/renderer";
import {Page, Text, View, Document, StyleSheet} from "@react-pdf/renderer";
import {ToWords} from 'to-words';

const styles = StyleSheet.create({
    page: {
      marginBottom:'20px'
    },
    section: {
      fontSize:10
    }
});
const Awlprint = (props) => {
    const history = useHistory();
    const [po,setpo] = useState(null);
    useEffect(() => {
        setpo(history.location.state.batch);
      },[props.po, history.location.state.batch]);

    const formatDate = (dt) => {
        let cdt = new Date(dt);
        let month = cdt.getMonth() + 1;
        let day = cdt.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return day+"-"+month+"-"+cdt.getFullYear() ;
      };
    let pdfDoc = null;
    if (po) { 
        const toWords = new ToWords();
        pdfDoc = (<Document>
        <Page size="A4" style={styles.page} >
            <View fixed style={{margin:'10 10 0 0', display:'flex', flexDirection:'row', justifyContent:'flex-end'}}>
                <Text style={{fontSize:'10'}} render={({ pageNumber, totalPages }) => (
                    `Page No: ${pageNumber} / ${totalPages}`
                    )} fixed />            
            </View>
            <View fixed style={{margin:'20 10 0 20', display:'flex', justifyContent:'space-between'}}>
                <View style={styles.section}>
                    <Text style={{fontSize:'14',fontWeight:'bold', margin:'auto'}}>VARDHMAN MAHAVEER OPEN UNIVERSITY, KOTA</Text>
                    <Text style={{fontSize:'12',fontWeight:'bold', margin:'auto'}}>{'AWARD LIST - '+po.exam}</Text>
                </View>    
                <View style={{margin:'20 10 10 20', display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                    <Text style={{fontSize:'10'}} className="ml-4">Batch : <span style={{fontSize:'10',fontWeight:'bold'}}>{po.batchcode}</span></Text>
                    <Text style={{fontSize:'10'}} className="ml-4">Course : <span style={{fontSize:'10',fontWeight:'bold'}}>{po.ccode}</span></Text>
                    <Text style={{fontSize:'10'}} className="ml-4">Max Marks : <span style={{fontSize:'10', fontWeight:'bold'}}>{po.mmarks}</span></Text>
                </View>
            </View>
            <View fixed style={{padding:'3 0 3 0', margin:'0 10 0 20', display:'flex', flexDirection:'row', justifyContent:'space-between',  borderStyle:'none', borderTopWidth:'1px', borderBottomWidth:'1px'}}>
                <Text style={{width:'5%',textAlign:'center', fontSize:'10'}}>S.No</Text>
                <Text style={{width:'20%',textAlign:'center', fontSize:'10'}}>Sch. No</Text>
                <Text style={{width:'10%',textAlign:'center',fontSize:'10'}}>{po.status !== 'created'?'Marks Obt':'Marks Obt    /'}</Text>
                {po.status !== 'created'?<Text style={{width:'15%',textAlign:'center',fontSize:'10'}}>Absentee Status</Text>:<Text style={{width:'15%',textAlign:'left',fontSize:'10'}}>Absentee Status</Text>}
                <Text style={{width:'30%',textAlign:'left', fontSize:'10'}}>{po.status !== 'created'?'Marks Obt(In Words)':''}</Text>
            </View>
            {po.marks.map((i,k) => (
                <View wrap={false} key={k} style={{height:'20px', margin:'0 10 0 20', display:'flex', flexDirection:'row', justifyContent:'space-between',  borderStyle:'none', borderBottomWidth:'1px'}}>
                    <Text style={{alignSelf: 'center',width:'7%',textAlign:'center',  fontSize:'10'}}>{k+1}</Text>
                    <Text style={{alignSelf: 'center',width:'20%',textAlign:'center',  fontSize:'10'}}>{i.controlno}</Text>
                    <Text style={{alignSelf: 'center',width:'10%',textAlign:'right', fontSize:'10'}}>{po.status !== 'submitted' && (i.award||0) === 0 && i.status !== 'ZE'?'':i.award}</Text>
                    {po.status !== 'created'?<Text style={{alignSelf: 'center',width:'15%',textAlign:'center', fontSize:'10'}}>{i.status}</Text>:<Text style={{alignSelf: 'center',width:'15%',textAlign:'left', fontSize:'10'}}>{i.status}</Text>}
                    <Text style={{alignSelf: 'center',width:'30%',textAlign:'left', fontSize:'10'}}>{po.status !== 'created'?i.status==='Ab'?'Absent':toWords.convert(i.award||0):''}</Text>
                </View>
            ))}
            {po.status !== 'created'?<View><View fixed style={{margin:'0 10 0 20', height:'40px', display:'flex', flexDirection:'row', alignItems:'flex-end', justifyContent:'space-between'}}>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}>{'Examiner : '+props.username}</Text>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}>{'Date : '+formatDate(new Date())}</Text>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}>Signature</Text></View>
                
                {po.type === 'pract1' ? <View fixed style={{margin:'0 10 0 20', height:'30px', display:'flex', flexDirection:'row', alignItems:'flex-end', justifyContent:'space-between'}}>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}>{'Internal Examiner Name'}</Text>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}>{'Signature'}</Text></View>:null}

                </View>:<View fixed style={{margin:'0 10 30 20', height:'60px', display:'flex', flexDirection:'row', alignItems:'flex-end', justifyContent:'space-between'}}>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}></Text>
                <Text style={{margin:'5', fontSize:'18', fontWeight:700}}>{'For Rough Work Only'}</Text>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}></Text>
            </View>}
        </Page>
        {po.invalid.length>0?<Page size="A4" style={styles.page} >
            <View fixed style={{margin:'10 10 0 0', display:'flex', flexDirection:'row', justifyContent:'flex-end'}}>
                <Text style={{fontSize:'10'}} render={({ pageNumber, totalPages }) => (
                    `Page No: ${pageNumber} / ${totalPages}`
                    )} fixed />            
            </View>
            <View fixed style={{margin:'20 10 0 20', display:'flex', justifyContent:'space-between'}}>
                <View style={styles.section}>
                    <Text style={{fontSize:'14',fontWeight:'bold', margin:'auto'}}>VARDHMAN MAHAVEER OPEN UNIVERSITY, KOTA</Text>
                    <Text style={{fontSize:'12',fontWeight:'bold', margin:'auto'}}>{'INVALID COPIES LIST - '+po.exam}</Text>
                </View>    
                <View style={{margin:'20 10 10 20', display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                    <Text style={{fontSize:'10'}} className="ml-4">Batch : <span style={{fontSize:'10',fontWeight:'bold'}}>{po.batchcode}</span></Text>
                    <Text style={{fontSize:'10'}} className="ml-4">Course : <span style={{fontSize:'10',fontWeight:'bold'}}>{po.ccode}</span></Text>
                    <Text style={{fontSize:'10'}} className="ml-4">Max Marks : <span style={{fontSize:'10', fontWeight:'bold'}}>{po.mmarks}</span></Text>
                </View>
            </View>
            <View fixed style={{padding:'3 0 3 0', margin:'0 10 0 20', display:'flex', flexDirection:'row', justifyContent:'space-between',  borderStyle:'none', borderTopWidth:'1px', borderBottomWidth:'1px'}}>
                <Text style={{width:'5%',textAlign:'center', fontSize:'10'}}>S.No</Text>
                <Text style={{width:'20%',textAlign:'center', fontSize:'10'}}>Copy No</Text>
                <Text style={{width:'20%',textAlign:'center', fontSize:'10'}}>Sch No</Text>
                <Text style={{width:'10%',textAlign:'center',fontSize:'10'}}>{'Marks Obt'}</Text>
                <Text style={{width:'30%',textAlign:'left', fontSize:'10'}}>{'Marks Obt(In Words)'}</Text>
            </View>
            {po.invalid.map((i,k) => (
                <View wrap={false} key={k} style={{height:'20px', margin:'0 10 0 20', display:'flex', flexDirection:'row', justifyContent:'space-between',  borderStyle:'none', borderBottomWidth:'1px'}}>
                    <Text style={{alignSelf: 'center',width:'7%',textAlign:'center',  fontSize:'10'}}>{k+1}</Text>
                    <Text style={{alignSelf: 'center',width:'20%',textAlign:'center',  fontSize:'10'}}>{i.copyno}</Text>
                    <Text style={{alignSelf: 'center',width:'20%',textAlign:'center',  fontSize:'10'}}>{i.controlno}</Text>
                    <Text style={{alignSelf: 'center',width:'15%',textAlign:'center', fontSize:'10'}}>{i.marks}</Text>
                    <Text style={{alignSelf: 'center',width:'30%',textAlign:'left', fontSize:'10'}}>{toWords.convert(i.marks||0)}</Text>
                </View>
            ))}
            {po.status !== 'created'?<View><View fixed style={{margin:'0 10 30 20', height:'60px', display:'flex', flexDirection:'row', alignItems:'flex-end', justifyContent:'space-between'}}>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}>{'Examiner : '+props.username}</Text>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}>{'Date : '+formatDate(new Date())}</Text>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}>Signature</Text></View>
                
                {po.type === 'pract1' ? <View fixed style={{margin:'0 10 30 20', height:'60px', display:'flex', flexDirection:'row', alignItems:'flex-end', justifyContent:'space-between'}}>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}>{'Internal Examiner Name and Signature'}</Text></View>:null}
                
                </View>:<View fixed style={{margin:'0 10 30 20', height:'60px', display:'flex', flexDirection:'row', alignItems:'flex-end', justifyContent:'space-between'}}>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}></Text>
                <Text style={{margin:'5', fontSize:'18', fontWeight:700}}>{'For Rough Work Only'}</Text>
                <Text style={{margin:'5', fontSize:'10', fontWeight:700}}></Text>
            
            </View>}
        </Page> : null}
    </Document>);
    }
    return (
        <PDFViewer style={{height:'100vh'}} width="100%" showToolbar={true}>
            {pdfDoc}
        </PDFViewer>
    );
};

const mapStateToProps = state => {
    return {
        username:state.auth.username,
        userid:state.auth.userid,
        email:state.auth.email,
        isAuth:state.auth.token!==null,
    }
}

export default connect(mapStateToProps)(Awlprint);